/**
 * @name ready
 * @description A paraméterként megadott utasítások a dokumentum betöltődésének végével hajtódnak végre.
 * @param {Function} fn - ez a függvény fut le, amint a document betöltődése véget ért
 * @example ready(function () { …<ezt hajtja végre betöltődés után>… } );
 * */


// function ready(fn) {
// 	if (document.readyState != 'loading') fn();
// 	else document.addEventListener('DOMContentLoaded', fn);
// }


// Ez a függvény a base.html elején, minden oldal betöltődésekor kerül meghívásra